module.exports = __webpack_public_path__ + "img/red-ribbon.fbb22e49.png";